import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12 20c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8m0 2c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.2111 11.1056c.7371.3685.7371 1.4203 0 1.7888l-4.7639 2.382C9.7823 15.6088 9 15.1253 9 14.382V9.618c0-.7433.7823-1.2268 1.4472-.8944z",
        clipRule: "evenodd"
    }, "1")
], "CreativeVideo", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
